import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link'

import {
  withStyles
} from 'material-ui/styles'

import * as SiteConfig from '../../config/Config'

const styles = theme => ({
  large: {
    background: `${theme.palette.type === "light" ? theme.palette.common.white : theme.palette.background.default} url("${SiteConfig.headerLogo.large.image}") no-repeat center`,
    position: "fixed",

    width: `${SiteConfig.headerLogo.large.width + SiteConfig.headerLogo.large.horiPadding}px`,
    height: `${SiteConfig.headerLogo.large.height + SiteConfig.headerLogo.large.verticalPadding}px`,

    top: 0,
    left: 0,
    zIndex: theme.zIndex.appBar + 1,
    pointer: "cursor",
  },
  medium: {
    background: `${theme.palette.type === "light" ? theme.palette.common.white : theme.palette.background.default} url("${SiteConfig.headerLogo.medium.image}") no-repeat center`,
    position: "fixed",

    width: `${SiteConfig.headerLogo.medium.width + SiteConfig.headerLogo.medium.horiPadding}px`,
    height: `${SiteConfig.headerLogo.medium.height + SiteConfig.headerLogo.medium.verticalPadding}px`,

    top: 0,
    left: 0,
    zIndex: theme.zIndex.appBar + 1,
    pointer: "cursor",
  },
  small: {
    background: `${theme.palette.type === "light" ? theme.palette.common.white : theme.palette.background.default} url("${SiteConfig.headerLogo.small.image}") no-repeat center`,
    position: "fixed",

    width: `${SiteConfig.headerLogo.small.width + SiteConfig.headerLogo.small.horiPadding}px`,
    height: `${SiteConfig.headerLogo.small.height + SiteConfig.headerLogo.small.verticalPadding}px`,

    top: 0,
    left: 0,
    zIndex: theme.zIndex.appBar + 1,
    pointer: "cursor",
  },
});

class Logo extends Component {
  render() {

    let renderLogo
    if(this.props.size === "large"){
      renderLogo = <div className={this.props.classes.large}></div>
    } else if(this.props.size === "medium"){
      renderLogo = <div className={this.props.classes.medium}></div>
    } else if(this.props.size === "small"){
      renderLogo = <div className={this.props.classes.small}></div>
    }

    return (
    <Link to="/">
        {renderLogo}
    </Link>
    );
  }
}

Logo.propTypes = {
  classes: PropTypes.object.isRequired,
  size: PropTypes.string.isRequired,
};

export default withStyles(styles)(Logo);


// WEBPACK FOOTER //
// ./src/components/Header/logo.js